'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export const useSessionStorageState = t0 => {
  const $ = _c(9);
  const {
    defaultValue,
    key
  } = t0;
  const [innerState, setInnerState] = useState(defaultValue ?? "");
  let t1;
  if ($[0] !== key) {
    t1 = value => {
      setInnerState(value);
      window.sessionStorage.setItem(key, value);
    };
    $[0] = key;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setSessionStorage = t1;
  let t2;
  let t3;
  if ($[2] !== defaultValue || $[3] !== key) {
    t2 = () => {
      const existingSessionValue = sessionStorage.getItem(key);
      if (existingSessionValue) {
        setInnerState(existingSessionValue);
      }
      if (!existingSessionValue && defaultValue) {
        sessionStorage.setItem(key, defaultValue);
      }
    };
    t3 = [defaultValue, key, setInnerState];
    $[2] = defaultValue;
    $[3] = key;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== innerState || $[7] !== setSessionStorage) {
    t4 = [innerState, setSessionStorage];
    $[6] = innerState;
    $[7] = setSessionStorage;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};